import React from 'react';
import { useSelector, connect } from 'react-redux';
import { changeStepForm, STEPS } from '../../redux/actions/PasosFormulario';
import { reset as resetForm } from 'redux-form';
import { reset } from '../../redux/actions/Coberturas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faKey, faClipboardList, faAddressCard, faCheck } from '@fortawesome/free-solid-svg-icons';
import '../../sass/TrackingBar.scss';


const TrackingBar = ({ changeStep, bindReset }) => {
    const step = useSelector(state => state.pasosReservacion);

    return (
        <div className="container-lg tracking-box" >
            <div className={`track-container active`}>
                <button type="button" onClick={() => bindReset()}>
                    <div className="track-icon">
                        <i className="fas fa-key"><FontAwesomeIcon icon={faKey} /></i>
                    </div>
                    <div className="track-title">
                        <p>HAZ TU RESERVA</p>
                    </div>
                </button>
            </div>
            <div className={`track-container ${step.stepActive.stepVehiculos && "active"}`} >
                <div className="track-line">
                    <hr />
                    <hr />
                </div>
            </div>
            <div className={`track-container ${step.stepActive.stepVehiculos && "active"}`}>
                <button type="button" onClick={() => (step.stepActive.stepVehiculos) && changeStep({ stepForm: STEPS.VEHICULO })}>
                    <div className="track-icon">
                        <i className="fas fa-car"><FontAwesomeIcon icon={faCar} /></i>
                    </div>
                    <div className="track-title">
                        <p>ESCOGE TU VEHÍCULO</p>
                    </div>
                </button>
            </div>
            <div className={`track-container ${step.stepActive.stepCoberturas && "active"}`}>
                <div className="track-line">
                    <hr />
                    <hr />
                </div>
            </div>
            <div className={`track-container ${step.stepActive.stepCoberturas && "active"}`}>
                <button type="button" onClick={() => (step.stepActive.stepCoberturas) && changeStep({ stepForm: STEPS.COBERTURAS })}>
                    <div className="track-icon">
                        <i className="fas fa-clipboard-list"><FontAwesomeIcon icon={faClipboardList} /></i>
                    </div>
                    <div className="track-title">
                        <p>COBERTURAS Y SERVICIOS ADICIONALES</p>
                    </div>
                </button>
            </div>
            <div className={`track-container ${step.stepActive.stepDatosCliente && "active"}`}>
                <div className="track-line">
                    <hr />
                    <hr />
                </div>
            </div>
            <div className={`track-container ${step.stepActive.stepDatosCliente && "active"}`}>
                <button type="button" onClick={() => (step.stepActive.stepDatosCliente) && changeStep({ stepForm: STEPS.DATOS_CLIENTE })}>
                    <div className="track-icon">
                        <i className="fas fa-address-card"><FontAwesomeIcon icon={faAddressCard} /></i>
                    </div>
                    <div className="track-title">
                        <p>INFORMACIÓN DEL CLIENTE</p>
                    </div>
                </button>
            </div>
            <div className={`track-container ${step.stepActive.stepConfirmacion && "active"}`}>
                <div className="track-line">
                    <hr />
                    <hr />
                </div>
            </div>
            <div className={`track-container ${step.stepActive.stepConfirmacion && "active"}`}>
                <button type="button" onClick={() => (step.stepActive.stepConfirmacion) && changeStep({ stepForm: STEPS.CONFIRMACION })}>
                    <div className="track-icon">
                        <i className="fas fa-check"><FontAwesomeIcon icon={faCheck} /></i>
                    </div>
                    <div className="track-title">
                        <p>CONFIRMACIÓN</p>
                    </div>
                </button>
            </div>
        </div >
    )
}

const mapDispatchToProps = dispatch => {
    return {
        changeStep: value => dispatch(changeStepForm(value)),
        bindReset: () => {
            dispatch(reset())
            dispatch(resetForm("FormDataCliente"))
        }
    }
}

export default connect(null, mapDispatchToProps)(TrackingBar)
